import React from "react";
import "./LanguageSelector.css";
import Suggestions from "../Suggestions/Suggestions";
import Flex from "../Flex/Flex";
import Text from "../Text/Text";
import useOutsideClick from "../../hooks/useOutsideClick";
import { useTranslation } from "react-i18next";
import FlagEN from "../../assets/FlagEN.png";
import FlagRU from "../../assets/FlagRU.png";

const LanguageSelector = React.memo(() => {
  const { i18n } = useTranslation("translation");
  const [isHidden, setIsHidden] = React.useState(true);
  const languages = [
    { id: 0, label: "RU" },
    { id: 1, label: "EN" },
  ];
  const getAbsoluteRef =
    React.useRef() as React.MutableRefObject<HTMLDivElement>;

  const handleToggleIsHidden = React.useCallback(() => {
    setIsHidden(x => !x);
  }, []);
  const handleOutsideClick = () => {
    setIsHidden(true);
  };
  const handleChangeLanguage = React.useCallback(
    (language: { id: number; label: string }) => {
      i18n.changeLanguage(language.label.toLocaleLowerCase());
    },
    [i18n]
  );

  useOutsideClick(getAbsoluteRef, handleOutsideClick);

  return (
    <Flex align="center">
      <div
        ref={getAbsoluteRef}
        onClick={handleToggleIsHidden}
        className="LanguageSelector"
      >
        <Flex gap={4}>
          <img
            className="LanguageSelector__Icon"
            src={i18n.language.toUpperCase() === "RU" ? FlagRU : FlagEN}
          />
          <Text size={3}>{i18n.language.toUpperCase()}</Text>
        </Flex>

        {!isHidden && (
          <Suggestions
            suggestions={languages}
            onClick={handleChangeLanguage}
          />
        )}
      </div>
    </Flex>
  );
});

export default LanguageSelector;
